import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass, unref as _unref, withModifiers as _withModifiers, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_2 = { class: "flex flex-col gap-4" }
const _hoisted_3 = { class: "overflow-hidden bg-white rounded-md sm:rounded-lg sm:shadow border border-gray-300" }
const _hoisted_4 = { class: "block border-b border-gray-200 bg-white px-4 py-5 sm:px-6 hover:bg-gray-50" }
const _hoisted_5 = { class: "-ml-4 -mt-4 flex flex-wrap items-center justify-between sm:flex-nowrap" }
const _hoisted_6 = { class: "flex gap-2 items-center" }
const _hoisted_7 = { class: "text-lg font-semibold leading-6 text-gray-800 tracking-tight hover:underline" }
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 0,
  class: "text-sm text-gray-400 mt-1"
}
const _hoisted_10 = { class: "ml-4 mt-4 flex flex-shrink-0 gap-2" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  role: "list",
  class: "divide-y divide-gray-200"
}
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "px-4 py-4 sm:px-6" }
const _hoisted_16 = { class: "mt-1 text-gray-500" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "px-4 py-4 sm:px-6" }

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { ArrowUpRightIcon, ClipboardDocumentIcon, EllipsisHorizontalIcon, PencilIcon } from '@heroicons/vue/20/solid'
import { computed, onMounted, reactive, ref } from 'vue'
import { useStore } from 'vuex'

import { useEntitlements } from '@/composables/useEntitlements'
import { dateObjectToServerDay, formatTimestamp } from '@/helpers/dates'
import { limitMessage, limitReached } from '@/helpers/planLimits'
import api from '@/store/api'
import { mapRelationship, mapRelationships, mapType } from '@/store/mappers'


export default {
  __name: 'StoreList',
  setup(__props) {

const vuexStore = useStore()
const { limit } = useEntitlements()

const data = reactive({
  list: computed(() => mapType('store').sort((a, b) => a.attributes.order - b.attributes.order)),
  isLoading: true,
  page: 0
})

const storesLimit = computed(() => limit('stores'))
const storesLimitReached = computed(() => limitReached(storesLimit.value, data.list.length))
const storesLimitMessage = computed(() => limitMessage('stores', storesLimit.value))

const getList = () => {
  api.call('GET', 'stores?included=fulfillment_methods,fulfillment_method_store_pairs').then(() => {
    data.isLoading = false
  })
}

const copyFlash = ref({})

const stores = computed(() =>
  mapType('store').sort((a, b) => (b.attributes.status === 'live') - (a.attributes.status === 'live'))
)

const methodActive = (store, method) => {
  const pairs = mapRelationships(store.relationships.fulfillment_method_store_pairs.data)
  return pairs.some(x => x.attributes.fulfillment_method_id.toString() === method.id)
}

const slots = store =>
  computed(() =>
    mapType('fulfillment_slot').filter(x => {
      const method = mapRelationship(x.relationships?.fulfillment_method?.data)
      if (method) return methodActive(store, method)
    })
  )

// doesn't take into account showing slots by arrival but it seems to work fine?
const slotsForDay = (store, day) =>
  slots(store).value.filter(x => x.attributes.fulfillment_date === dateObjectToServerDay(day))

const getSlots = store => days => {
  for (const day of days) {
    for (const slot of slotsForDay(store, day)) {
      vuexStore.commit('DESTROY_OBJECT', { data: slot })
    }
  }
  const from = dateObjectToServerDay(days.at(0))
  const to = dateObjectToServerDay(days.at(-1))
  return api.call(
    'GET',
    `fulfillment_slots?date_from=${from}&date_to=${to}&included=duplicator,fulfillment_availabilities`
  )
}

const isCateringStore = store => store.attributes?.platform === 'catering'

const copyLink = store => {
  navigator.clipboard.writeText(store.attributes.store_link)
  copyFlash.value[store.id] = true
  setTimeout(() => {
    copyFlash.value[store.id] = false
  }, 3000)
}

const onPageChange = e => {
  data.page = e
}

onMounted(() => {
  getList()
})

return (_ctx, _cache) => {
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_router_link = _resolveComponent("router-link")
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_FulfillmentSlotCalendar = _resolveComponent("FulfillmentSlotCalendar")
  const _component_table_pagination = _resolveComponent("table-pagination")
  const _component_ListLayout = _resolveComponent("ListLayout")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, { text: "Stores" }, {
        right: _withCtx(() => [
          (!storesLimitReached.value)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/store/stores/new"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_NeueButton, { type: "primary" }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("New", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("p", _hoisted_1, _toDisplayString(storesLimitMessage.value), 1),
                _createVNode(_component_NeueButton, {
                  type: "inactive",
                  title: storesLimitMessage.value
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("New", -1)
                  ]))]),
                  _: 1
                }, 8, ["title"])
              ], 64))
        ]),
        _: 1
      })
    ]),
    main: _withCtx(() => [
      _createVNode(_component_ListLayout, {
        "is-loading": data.isLoading,
        "list-length": data.list.length,
        "empty-state-heading": "No stores yet",
        "empty-state-description": "Get started by adding stores"
      }, {
        table: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.list.slice(data.page * 5, data.page * 5 + 5), (store) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_router_link, {
                      class: "ml-4 mt-4",
                      to: '/store/stores/' + store.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("h3", _hoisted_7, _toDisplayString(store.attributes.store_name), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["px-2 text-xs leading-5 font-semibold rounded-full", 
                          store.attributes.status === 'live'
                            ? 'bg-green-100 text-green-800'
                            : 'bg-gray-100 text-gray-800'
                        ])
                          }, _toDisplayString(store.attributes.status === 'live' ? 'Active' : 'Private'), 3),
                          (store.attributes.over_plan_limit)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "px-2 text-xs leading-5 font-semibold rounded-full bg-gray-200 text-gray-700",
                                title: storesLimitMessage.value
                              }, " Over plan limit ", 8, _hoisted_8))
                            : _createCommentVNode("", true)
                        ]),
                        (_unref(formatTimestamp)(store.attributes.updated_at))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Last updated " + _toDisplayString(_unref(formatTimestamp)(store.attributes.updated_at)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createElementVNode("div", _hoisted_10, [
                      (isCateringStore(store))
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "hidden sm:inline-flex ml-3",
                            to: '/store/stores/' + store.id,
                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_NeueButton, { type: "secondary" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(PencilIcon), {
                                    class: "-ml-1 mr-2 h-5 w-5",
                                    "aria-hidden": "true"
                                  }),
                                  _cache[3] || (_cache[3] = _createTextVNode(" Edit Details ", -1))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : (_openBlock(), _createBlock(_component_NeueButton, {
                            key: 1,
                            type: "secondary",
                            class: _normalizeClass(["hidden sm:inline-flex ml-3", copyFlash.value[store.id] && '!bg-green-500 !text-white']),
                            onClick: _withModifiers($event => (copyLink(store)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ClipboardDocumentIcon), {
                                class: "-ml-1 mr-2 h-5 w-5",
                                "aria-hidden": "true"
                              }),
                              _createTextVNode(" Cop" + _toDisplayString(copyFlash.value[store.id] ? 'ied' : 'y') + " link to store ", 1)
                            ]),
                            _: 2
                          }, 1032, ["class", "onClick"])),
                      _createVNode(_unref(Menu), { as: "div" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(MenuButton), null, {
                            default: _withCtx(() => [
                              _createVNode(_component_NeueButton, { type: "secondary" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(EllipsisHorizontalIcon), {
                                    class: "h-5 w-5",
                                    "aria-hidden": "true"
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition ease-out duration-100",
                            "enter-from-class": "transform opacity-0 scale-95",
                            "enter-to-class": "transform opacity-100 scale-100",
                            "leave-active-class": "transition ease-in duration-75",
                            "leave-from-class": "transform opacity-100 scale-100",
                            "leave-to-class": "transform opacity-0 scale-95"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(MenuItems), { class: "absolute right-0 z-10 mt-2 w-56 origin-top-right py-1 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                                default: _withCtx(() => [
                                  (isCateringStore(store))
                                    ? (_openBlock(), _createBlock(_unref(MenuItem), { key: 0 }, {
                                        default: _withCtx(({ active }) => [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: _normalizeClass([active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', "group flex items-center px-4 py-2 text-sm w-full text-left"]),
                                            onClick: _withModifiers($event => (copyLink(store)), ["stop"])
                                          }, [
                                            _createVNode(_unref(ClipboardDocumentIcon), {
                                              class: "mr-3 h-5 w-5 text-gray-700 group-hover:text-gray-900",
                                              "aria-hidden": "true"
                                            }),
                                            _createTextVNode(" Cop" + _toDisplayString(copyFlash.value[store.id] ? 'ied' : 'y') + " link to store ", 1)
                                          ], 10, _hoisted_11)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : (_openBlock(), _createBlock(_unref(MenuItem), { key: 1 }, {
                                        default: _withCtx(({ active }) => [
                                          _createVNode(_component_router_link, {
                                            class: _normalizeClass([active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', "group flex items-center px-4 py-2 text-sm w-full text-left"]),
                                            to: '/store/stores/' + store.id
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(PencilIcon), {
                                                class: "mr-3 h-5 w-5 text-gray-700 group-hover:text-gray-900",
                                                "aria-hidden": "true"
                                              }),
                                              _cache[4] || (_cache[4] = _createTextVNode(" Edit store ", -1))
                                            ]),
                                            _: 1
                                          }, 8, ["class", "to"])
                                        ]),
                                        _: 2
                                      }, 1024)),
                                  _createVNode(_unref(MenuItem), null, {
                                    default: _withCtx(({ active }) => [
                                      _createElementVNode("a", {
                                        href: store.attributes.store_link,
                                        target: "_blank",
                                        class: _normalizeClass([active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', "group flex items-center px-4 py-2 text-sm w-full text-left"])
                                      }, [
                                        _createVNode(_unref(ArrowUpRightIcon), {
                                          class: "mr-3 h-5 w-5 text-gray-700 group-hover:text-gray-900",
                                          "aria-hidden": "true"
                                        }),
                                        _cache[5] || (_cache[5] = _createTextVNode(" Open store as customer ", -1))
                                      ], 10, _hoisted_12)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ]),
                _createElementVNode("ul", _hoisted_13, [
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "truncate text-base font-medium text-gray-600 tracking-tight" }, "Products", -1)),
                        _createElementVNode("div", _hoisted_16, _toDisplayString(store.relationships?.products?.data?.length ?? 0) + " product" + _toDisplayString((store.relationships?.products?.data?.length ?? 0) === 1 ? '' : 's'), 1)
                      ])
                    ])
                  ]),
                  (store.relationships?.fulfillment_method_store_pairs?.data?.length)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_FulfillmentSlotCalendar, {
                            slots: slots(store).value,
                            store: store,
                            editable: true,
                            onGetSlots: x => getSlots(store)(x)
                          }, null, 8, ["slots", "store", "onGetSlots"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 256))
          ])
        ]),
        pagination: _withCtx(() => [
          _createVNode(_component_table_pagination, {
            items: data.list,
            page: data.page,
            "page-size": 5,
            onOnPageChange: onPageChange
          }, null, 8, ["items", "page"])
        ]),
        _: 1
      }, 8, ["is-loading", "list-length"])
    ]),
    _: 1
  }))
}
}

}